import Seo from "../components/Seo";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { MEDIA } from "../lib/media";
import ProductCard from "../components/ProductCard";
import { Gift } from "lucide-react";

const CHIPS = [["До 200 €", { max_price: 200 }], ["До 500 €", { max_price: 500 }],
  ["За нов дом", { room: "Дневна" }], ["За офис", { room: "Офис" }],
  ["Морски пейзажи", { search: "море" }], ["Абстрактни", { category: "абстрактни-картини" }]];

export default function Gifts() {
  const [active, setActive] = useState(1);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { ...CHIPS[active][1], limit: 8, sort: "recommended" } })
      .then(({ data }) => setProducts(data.items));
  }, [active]);

  return (
    <div data-testid="gifts-page">
      <Seo title="Картини за подарък" path="/podaratsi" description="Оригинална картина е незабравим подарък. Изберете ръчно рисувана картина за нов дом, юбилей или специален повод от галерия PenichArt." />
      <section className="relative bg-navy text-ivory">
        <img src={MEDIA.gift} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 py-20 md:py-28 text-center">
          <Gift size={36} className="text-gold mx-auto mb-5" strokeWidth={1.3} />
          <h1 className="font-serif text-4xl md:text-5xl text-white">Подарък, който остава</h1>
          <p className="text-ivory/80 mt-4 max-w-xl mx-auto">
            Картина за нов дом, рожден ден, юбилей, сватба или специален човек.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex flex-wrap gap-2.5 justify-center mb-10">
          {CHIPS.map(([label], i) => (
            <button key={label} onClick={() => setActive(i)}
                    className={`text-sm px-5 py-2.5 border transition-colors ${i === active ? "bg-gold text-white border-gold" : "border-navy/30 text-navy hover:border-gold"}`}
                    data-testid={`gift-filter-${i}`}>
              {label}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
        <div className="text-center mt-12">
          <Link to="/kartini" className="btn-navy-outline px-8 py-3 rounded-sm">Виж всички картини</Link>
        </div>
      </section>
    </div>
  );
}
